import { defineStore } from 'pinia'
import { fetchItems } from '@/api/news'
import useCrudStore from '@/hooks/useCrudStore'

export const useNewsStore = defineStore('news', () => {
  const { items, GetItems } = useCrudStore({
    fetchItems
  })

  return {
    items,
    GetItems
  }
})
